import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import * as domainConstants from '../../../constants/DomainConstants';
import Jaarbedragen from "./jaarbedragenComponent";
import Row from "../../common/Row";
import Button from "../../common/Button";
import DownloadUploadFile from "../../common/DownloadUploadFiles";
import Fieldset from "../../common/Fieldset";
import moment from "moment";
import { getFilesForDossierComponent } from "../../common/DownloadUploadFilesHelper";

const OverzichtForm = (props) => {
    const {
        model,
        color,
        documenten,
        generateRapport,
        isPollingDocument
    } = props;

    return (<Section title={domainConstants.FinancieelTitels.FinancieleDuurzaamheid} color={color}>
        <Form
            title="Overzicht financiële duurzaamheid"
            name="overzichtFinancieleDuurzaamheid"
            isNotRequired>
            <Fieldset>
                <FieldsetSubHeader>TOTAAL BEDRIJFSRESULTAAT</FieldsetSubHeader>
                <Jaarbedragen key={"Bedrijfsresultaat_Totalen"} model={model.bedrijfsResultaat} showAsTotalen />
                <br />
                <FieldsetSubHeader>TOTAAL FINANCIEEL RESULTAAT</FieldsetSubHeader>
                <Jaarbedragen key={"FinancieelResultaat_Totalen"} model={model.financieelResultaat} showAsTotalen />
                <br />
                <FieldsetSubHeader>TOTAAL UITZONDERLIJK RESULTAAT</FieldsetSubHeader>
                <Jaarbedragen key={"UitzonderlijkResultaat_Totalen"} model={model.uitzonderlijkResultaat} showAsTotalen />
                <br />
                <FieldsetSubHeader>TOTAAL RESULTAAT</FieldsetSubHeader>
                <Jaarbedragen key={"TotaalResultaat_Totalen"} model={model.resultaat} showAsTotalen showGreenRed />
                <br />
            </Fieldset>
            <Fieldset title="Rapport financiële duurzaamheid">
                <Row>
                    <DownloadUploadFile
                        dossierId={model.dossierId}
                        title="Rapporten"
                        size={6}
                        tab={domainConstants.DocumentTab.MinimaleEisen}
                        component={domainConstants.ComponentName.DuurzaamheidsRapport}
                        files={getFilesForDossierComponent(domainConstants.ComponentName.DuurzaamheidsRapport, documenten)}
                        color={color}
                        defaultText="Nog geen documenten beschikbaar"
                        downloadOnly />

                    <div className="o-col-6" style={{paddingTop: '15px'}}>
                        <Button onClick={generateRapport} disabled={isPollingDocument}>Genereer rapport</Button>
                        {isPollingDocument ? <p>Even wachten aub</p> : ""}

                    </div>
                </Row>
                <Row>
                    {model.datumFinancieleDuurzaamheidRapportGeneratie ? <p>Documenten gegenereerd op: {moment(model.datumFinancieleDuurzaamheidRapportGeneratie).format("DD-MM-YYYY HH:mm")}</p> : ""}
                </Row>
            </Fieldset>
        </Form>
    </Section>);
};

OverzichtForm.propTypes = {
    color: PropTypes.string,
    model: PropTypes.object,
    documenten: PropTypes.array,
    generateRapport: PropTypes.func,
    isPollingDocument: PropTypes.bool
};

export default OverzichtForm;